import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import instagram from './images/replaceME.jpg';

export default () => (
  <div>
    <Helmet
      title='Fire Island Ferries | Atlantique'
      meta={[
        {
          name: 'description',
          content:
            'A secluded oasis on Fire Island with limited access providing serentiy unlike anywhere elese.',
        },
        {
          name: 'keywords',
          content:
            'Atlantique, Fire Island, Ferries, New York, Long Island, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className='container p-0'>
      <PageHeader beach='Atlantique'>
        <h2>Communities</h2>
        <h1>Atlantique</h1>
        <p>Amenities</p>
        <div className='amenities'>
          {Amenities.byBeach('Atlantique').map((item) => (
            <i
              key={item.text}
              className={`icon-${item.icon}`}
              title={item.text}
            />
          ))}
        </div>
        <div>
          <Link className='btn btn-outline-light' to='/schedules/atlantique'>
            Schedules
          </Link>
          &nbsp;&nbsp;
          <Link className='btn btn-outline-light' to='/directory'>
            Directory
          </Link>
        </div>
      </PageHeader>
    </div>
    <div className='container page'>
      <div className='row'>
        <div className='col-xl'>
          <div className='heading'>
            <h1>About Atlantique</h1>
          </div>
          <p>
            The community of Atlantique is secluded from its neighboring towns
            due to thick sandy paths that are extremely difficult to traverse by
            bike. The residents of Atlantique enjoy a serenity unlike anywhere
            else on Fire Island because of its limited accessibility.
          </p>
          <p>
            The easiest way to visit Atlantique is by ferry, water taxi, or
            personal boat. Residents of this community and/or the township of
            the Town of Islip are able to dock their boats at the Town of Islip
            Marina. The marina has 159 boat slips (first come first serve) as
            well as bathhouses for boaters and beachgoers. In addition to the
            marina there is a great playground for kids, and a little beachside
            concession stand, commonly referred to as “The Shack.”
          </p>
        </div>
        {/* <div className="col-xl-4">
          <Instagram account="fiferries" datestamp="June 23, 2016" profile={fiferries} image={instagram} link="https://www.instagram.com/fiferries" className="mx-auto" />
        </div> */}
      </div>
      <Tip title="Captain's Tip">
        The Shack cranks out great food and drinks, perfect for a day or night
        at the beach, and often has live music.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Atlantique is available by Fire Island Ferries
        from Bay Shore.{' '}
        <Link to='/schedules/atlantique'>Click here for schedules.</Link>
      </p>
      <p>
        <a href='http://www.fireislandwatertaxi.com'>Water Taxi</a> service is
        available to and from Atlantique during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
